module.exports = __webpack_public_path__ + "prod/1.42.2/img/api-one.6c4075bf.png";